<div class="image-only">
  <loading class="posF vh-center" *ngIf="loading" [scale]="1.5"></loading>
  <img data-testid="checkup-image-only" *ngIf="!loading && imagePath" [src]="imagePath" [alt]="type || 'Instant checkup'"/>
  <div data-testid="checkup-image-only-empty" class="text-center py-5" *ngIf="!loading && !imagePath">Image not found.</div>
</div>
